<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n()
const router = useRouter();
const go_back = () => router.go(-1);
</script>

<template>
    <div class="NotFound text-center text-3xl mt-8">
        <p class="">{{ t('receipt.not_found.page_not_found') }}</p>
    </div> 
    <div class="max-w-xs m-auto text-center mt-8">
        <v-btn @click="go_back" class="inline-block">{{ t('receipt.not_found.go_back') }}</v-btn>
    </div>
</template>

<style scoped>
</style>